import React from 'react';
import '../components/Footer.css'
import {FaFacebook,FaLinkedin,FaMailBulk,FaPhone,FaSearchLocation,FaTwitter} from 'react-icons/fa'

const Footer = () => {
    return (
        <div className='footer'>
            <div className='footer-container'>
                <div className='left'>
                    <div className='location'>
                        <FaSearchLocation size={20} style={{color:'white' , marginRight:'0.5rem'}} />
                        <div>
                            <p>123 Acem St.</p>
                            <h4>Housten, Tx</h4>
                        </div>
                    </div>
                    <div className='phone'>
                        <h4> <FaPhone size={20} style={{color:'white' , marginRight:'0.5rem'}} /> 125-457-4878</h4>
                    </div>
                    <div className='email'>
                        <h4><FaMailBulk size={20} style={{color:'white' , marginRight:'0.5rem'}} /> trips@galaxy.com</h4>
                    </div>
                </div>
                <div className='right'>
                    <div>
                        <h4>About The Campany</h4>
                        <p>"Lorem ipsum dolor sit amet, consectetur adipisicing elit. 
                        Cum commodi soluta nam architecto blanditiis labore fuga. Atque, 
                        maiores neque. Consequuntur . "</p>

                    </div>
                    <div>
                        <FaFacebook size={30} style={{color:'white' , marginRight:'0.5rem'}}/>
                        <FaLinkedin size={30} style={{color:'white' , marginRight:'0.5rem'}}/>
                        <FaTwitter size={30} style={{color:'white' , marginRight:'0.5rem'}}/>
                    </div>
                </div>
            </div>
            
        </div>
    );
}

export default Footer;
